
export { linkButtonTitles } from "/vercel/path0/libs/intl/src/lib/translations/common-carousel/index.ts"